import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FirmCollaboratorType } from '@app/core/state/types/firm-collaborator.types';
import { BlFrontendButtonComponent } from '@core/wrappers/bl-frontend-button.component';
import { TranslocoModule } from '@jsverse/transloco';
import { getTranslationProvider } from 'src/app/core/i18n/getTranslationProvider';
import { TranslatableFormDialogBaseComponent } from 'src/app/core/i18n/translatable-form-dialog-base.component';

interface ConfirmRemoveFirmCollaboratorDialogData {
  firmCollaborator: FirmCollaboratorType;
}

interface ConfirmRemoveFirmCollaboratorDialogResult {
  confirmed?: boolean;
}

const TRANSLATIONS_SCOPE = 'confirmRemoveFirmCollaboratorDialogComponent';

@Component({
  template: `
    <ng-container *transloco="let t; prefix: scope">
      <p>{{ t('areYouSureToRemove', { firmCollaboratorName: firmCollaborator.name }) }}</p>
      <div class="flex justify-end mt-6 gap-2">
        <bl-frontend-button
          [text]="'shared.cancel' | transloco"
          variant="secondary"
          (click)="close(null)"></bl-frontend-button>
        <bl-frontend-button
          [text]="'shared.yesContinue' | transloco"
          variant="primary"
          (click)="close({ confirmed: true })"></bl-frontend-button>
      </div>
    </ng-container>
  `,
  standalone: true,
  providers: [getTranslationProvider(TRANSLATIONS_SCOPE)],
  imports: [CommonModule, BlFrontendButtonComponent, TranslocoModule],
})
export class ConfirmRemoveFirmCollaboratorDialogComponent extends TranslatableFormDialogBaseComponent<
  ConfirmRemoveFirmCollaboratorDialogData,
  ConfirmRemoveFirmCollaboratorDialogResult
> {
  firmCollaborator: FirmCollaboratorType;

  protected override onInitialized = () => {
    this.firmCollaborator = this.config.data.firmCollaborator;
  };

  protected static override getTranslationScope(): string {
    return TRANSLATIONS_SCOPE;
  }

  protected static override getDialogConfig(translation: Record<string, string>) {
    return {
      header: translation.removeFirmCollaborationQuestion,
      width: '500px',
    };
  }
}
